// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605221103/js/" + chunkId + "." + {"44":"df975775","225":"c804ee1b","481":"b5016701","486":"c10ea28f","770":"67371a73"}[chunkId] + ".0.10173148818067834.chunk.js";
};